import React from 'react';

const TabletIcon = ({
  style = {},
  width = '100%',
  className = '',
  height = '100%',
  viewBox = '0 0 24 24',
  onClick = () => {}
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    onClick={onClick}
  >
    <path d="M19 24c1.104 0 2-.896 2-2v-20c0-1.104-.896-2-2-2h-14c-1.104 0-2 .896-2 2v20c0 1.104.896 2 2 2h14zm-14-3v-18h14v18h-14zm6.5 1.5c0-.276.224-.5.5-.5s.5.224.5.5-.224.5-.5.5-.5-.224-.5-.5z" />
  </svg>
);

export default TabletIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/tabletIcon.js